import {FunctionalComponent, h} from "preact";
import {useEffect} from "preact/hooks";

const ChangeBackground: FunctionalComponent<{
    msgID: string;
    backgroundData: any;
    changeBackgroundCallback: (backgroundData: any) => void;
    tickCallback: () => void;
}> = ({
          msgID,
          backgroundData,
          changeBackgroundCallback,
          tickCallback
      }) => {

    useEffect(() => {
        // log.info(`typing for msgID ${msgID}`);
        /** advance queue */
        changeBackgroundCallback(backgroundData);
        tickCallback();
    }, [msgID]);

    return null;
}

export default ChangeBackground;
